<div class="field field-select">
  @if (label) {
    <span class="label" [class.hide-text]="hideLabel">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <select
    [ngModel]="model"
    (ngModelChange)="modelChange.emit($event)"
    [class.model-empty]="!model"
    [class.error-field]="error"
    [ngStyle]="{'max-width': maxWidth ? (maxWidth + 'px') : 'auto'}"
    [disabled]="disabled"
    >
    @for (option of localOptions; track option) {
      @if (!getOptionsToExclude().includes(option.value) && !hasParent(option) && !isParent(option)) {
        <option [ngValue]="option.value">{{option.title}}</option>
      }
      @if (isParent(option)) {
        <optgroup [label]="option.title">
          @for (option of getChildren(option); track option) {
            @if (!getOptionsToExclude().includes(option.value)) {
              <option [ngValue]="option.value">{{option.title}}</option>
            }
          }
        </optgroup>
      }
    }
  </select>
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>